<p translate [innerHTML]="safeHtml"></p>
